import { Box, Typography, Grid } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
  tagsContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'wrap'
  },
  tagLabel: {
    marginRight: 8,
    marginTop: 8,
    fontSize: 12,
    color: '#616161',
    backgroundColor: '#f3f5fb',
    borderRadius: 6,
    padding: '4px 8px'
  },
  tagPlaceholder: {
    width: '100%',
    height: 68
  }
}));

export const VideoCardTags = ({ locale, tags, usePlaceholder = true, color, backgroundColor }) => {
  const { classes } = useStyles();
  if ((!tags || tags.length === 0) && usePlaceholder) {
    return <Box className={classes.tagPlaceholder} />;
  } else if (tags && tags.length > 0) {
    return (
      <Box className={classes.tagsContainer}>
        {tags.map((tag, index) => (
          <Typography key={`tag-${index}`} variant="body1" className={classes.tagLabel} style={{ color: color }}>
            {tag[locale]}
          </Typography>
        ))}
      </Box>
    );
  } else {
    return <></>;
  }
};
